@import 'styles/variables';
@import 'styles/mixins';

.contents {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subTitle {
  @include md-regular;
}

.largerLeftContent {
  max-width: 418px;
}
